import React from "react"
import { Box, Typography } from "@mui/material"
import Carousel from "react-material-ui-carousel"
import parse from "html-react-parser"
import { backdrops } from "./const"

export function LandingPage() {
  return (
    <Box>
      <Carousel
        autoPlay={true}
        indicators={true}
        swipe={false}
        interval={20000}
        duration={500}
        navButtonsAlwaysVisible={true}
        navButtonsAlwaysInvisible={false}
        animation={"fade"}
        fullHeightHover={true}
        cycleNavigation={true}
      >
        {backdrops.map((item) => (
          <Box
            key={item.title}
            sx={{
              backgroundImage: `url(${item.backdrop})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "50% 50%",
              padding: "80px",
              paddingLeft: "180px",
              paddingRight: "160px",
            }}
          >
            <Typography variant={"h2"} sx={{ mt: 1, color: "#FAF9F6", fontWeight: "550" }}>
              {item.title}
            </Typography>
            <Typography variant={"h4"} sx={{ mt: 1, color: "#FAF9F6", fontWeight: "550" }}>
              {parse(item.blurb)}
            </Typography>
            <Typography
              className={"arrow-after"}
              align="right"
              sx={{ mt: 1, color: "#FAF9F6", textTransform: "uppercase" }}
            >
              Find out more
            </Typography>
          </Box>
        ))}
      </Carousel>
    </Box>
  )
}
